/**
 * Inyecta x-gobik-token en peticiones al API Gateway Gobik.
 * Debe coincidir con gobik_api_token en gobik-integration/template.yaml
 */
(function () {
  var TOKEN = "mGeU5]PY?48;RZfb!sJ.@d'tLR0Ly)5I";
  var API_HOST = 'execute-api.us-west-2.amazonaws.com';

  window.GOBIK_API_TOKEN = TOKEN;

  function isGobikApiUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return url.indexOf(API_HOST) !== -1;
  }

  function withTokenHeaders(init) {
    init = init || {};
    var headers = init.headers;
    if (headers instanceof Headers) {
      if (!headers.has('x-gobik-token')) {
        headers.set('x-gobik-token', TOKEN);
      }
      return init;
    }
    var h = {};
    if (headers && typeof headers === 'object') {
      if (Array.isArray(headers)) {
        headers.forEach(function (pair) {
          h[pair[0]] = pair[1];
        });
      } else {
        h = Object.assign({}, headers);
      }
    }
    if (!h['x-gobik-token'] && !h['X-Gobik-Token']) {
      h['x-gobik-token'] = TOKEN;
    }
    init.headers = h;
    return init;
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (isGobikApiUrl(url)) {
        init = withTokenHeaders(init);
      }
      return origFetch.call(this, input, init);
    };
  }

  var OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    window.XMLHttpRequest = function () {
      var xhr = new OrigXHR();
      var origOpen = xhr.open;
      var origSend = xhr.send;
      var _url = '';
      xhr.open = function (method, url) {
        _url = url || '';
        return origOpen.apply(xhr, arguments);
      };
      xhr.setRequestHeader = (function (origSet) {
        return function (name, value) {
          xhr._gobikHeaders = xhr._gobikHeaders || {};
          xhr._gobikHeaders[name] = value;
          return origSet.apply(xhr, arguments);
        };
      })(xhr.setRequestHeader);
      xhr.send = function () {
        if (isGobikApiUrl(_url)) {
          try {
            xhr.setRequestHeader('x-gobik-token', TOKEN);
          } catch (e) {
            /* ya enviado o estado inválido */
          }
        }
        return origSend.apply(xhr, arguments);
      };
      return xhr;
    };
  }
})();
